import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup, FormControlLabel } from 'components';
import styles from './RadioPreview.scss';

const RadioPreview = ({
    options,
    defaultSelected,
    onChangeSelected,
    isDisabled,
    ...radioProps
}) => {
    const [selected, setSelected] = useState(defaultSelected);
    const handleChangeSelected = event => {
        const value = event.target.value;
        setSelected(value);
        onChangeSelected(value);
    };

    return (
        <RadioGroup
            value={selected}
            disabled={isDisabled}
            onChange={handleChangeSelected}
        >
            { options.map((option, index) =>
                <FormControlLabel
                    key={index}
                    value={option.id}
                    control={
                        <Radio
                            color='primary'
                            disabled={isDisabled}
                            { ...radioProps}
                        />
                    }
                    label={<div className={styles.label}>{ option.text }</div>}
                />
            )}
        </RadioGroup>
    );
};

RadioPreview.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        text: PropTypes.string
    })).isRequired,
    defaultSelected: PropTypes.string,
    onChangeSelected: PropTypes.func,
    isDisabled: PropTypes.bool
};

RadioPreview.defaultProps = {
    defaultSelected: '',
    onChangeSelected: () => {},
    isDisabled: false
};

export default RadioPreview;
